import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Highlight} from '../../components/eca-doc-list/eca-document-viewer/highlight-panel/EcaHighLightedPanel';

interface TextState {
  text: string;
  toggleOnHighlight: boolean;
  searchTerm: string;
  highlights: Highlight[];
}

const initialState: TextState = {
  text: '',
  toggleOnHighlight: true,
  searchTerm: '',
  highlights: [],
};

const highLightTextSlice = createSlice({
  name: 'highlightText',
  initialState,
  reducers: {
    setHighLightText: (state, action: PayloadAction<string>) => {
      state.text = action.payload;
    },
    setToggleOnHighlight: (state, action: PayloadAction<boolean>) => {
      state.toggleOnHighlight = action.payload;
    },
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
    setHighlights: (state, action: PayloadAction<Highlight[]>) => {
      state.highlights = action.payload;
    },
  },
});

export const {
  setToggleOnHighlight,
  setHighlights,
  setHighLightText,
  setSearchTerm,
} = highLightTextSlice.actions;
export default highLightTextSlice.reducer;
